// Icono liviano: dibuja el SVG estático directo desde la definición de font-awesome,
// sin la maquinaria de @fortawesome/react-fontawesome (que era ~2x del render por foto).
// Mismo glifo/aspecto, costo de render ~= JSX estático.
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import type { CSSProperties } from "react";

export function Fa({
  icon,
  style,
  className,
}: {
  icon: IconDefinition;
  style?: CSSProperties;
  className?: string;
}) {
  const [w, h, , , path] = icon.icon;
  const d = Array.isArray(path) ? path.join(" ") : path;
  return (
    <svg
      className={className}
      style={style}
      viewBox={`0 0 ${w} ${h}`}
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden="true"
      role="img"
    >
      <path d={d} />
    </svg>
  );
}
